import React from 'react';
import styles from './index.module.scss';
import UnknownBlock from '../../_block_components/unknown_block';

const UnknownTemplate = ({ contentData, path_to_folder, templateName, sectionType }) => {

  const renderBlock = (contentData) => {
    return <UnknownBlock blockData={contentData} path_to_folder={path_to_folder} />;
  };

  return (
    <div className={styles.unknownTemplate}>
      <h2 className={styles.title}>Неизвестный Шаблон</h2>
      <div className={styles.infoContainer}>
        {sectionType && (
          <div className={styles.sectionTypeBlock}>
            <span className={styles.label}>Тип раздела:</span>
            <span className={styles.sectionType}>{sectionType}</span>
          </div>
        )}
        {templateName && (
          <div className={styles.templateNameBlock}>
            <span className={styles.label}>Имя шаблона:</span>
            <span className={styles.templateName}>{templateName}</span>
          </div>
        )}
      </div>
      <p className={styles.description}>Компонент для неизвестного шаблона</p>

      {contentData && Array.isArray(contentData) && (
        <div className={styles.blocksContainer}>
          <h3>Блоки контента:</h3>
          {contentData.map((block, index) => (
            <div key={index} className={styles.blockWrapper}>
              {renderBlock(block)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UnknownTemplate;
